import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import {
  LIST_STATES,
  LIST_STATES_COMPLETE,
  LIST_STATES_WITH_ANNOTATION,
} from 'civil-status/constants/states-act';
import { memo, useMemo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

interface ListStateActProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  isComplete?: boolean;
  isWithAnnotation?: boolean;
  withoutId?: string;
}

const ListStateActComponent = ({
  disabled,
  onChange,
  value,
  error,
  isComplete,
  withoutId,
  isWithAnnotation,
}: ListStateActProps): React.ReactElement => {
  const list: Array<ItemVM> = useMemo(() => {
    let arrRes = [];
    if (isComplete) {
      arrRes = LIST_STATES_COMPLETE;
    } else {
      if (isWithAnnotation) {
        arrRes = LIST_STATES_WITH_ANNOTATION;
      } else {
        arrRes = LIST_STATES;
      }
    }

    if (withoutId) {
      arrRes = arrRes.filter((item) => item.id !== withoutId);
    }

    return arrRes;
  }, [isComplete]);

  return (
    <PmiFormControl fullWidth>
      <InputLabel id="state-list-label">Stato</InputLabel>
      <PmiSelect
        labelId="state-list-label"
        id="state-list"
        name="state-list"
        value={value}
        label="Stato"
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list?.map((state: ItemVM) => (
          <MenuItem key={state.id} value={state.id}>
            {state.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListStateActComponent.displayName = 'List State Research component';

const ListStateAct = memo(ListStateActComponent);

export default ListStateAct as typeof ListStateActComponent;
